"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DataServiceError: function() {
        return DataServiceError;
    },
    DataService: function() {
        return DataService;
    }
});
const _jsonOrThrow = require("../../../infra-sk/modules/jsonOrThrow");
const _progress = require("../progress/progress");
let DataServiceError = class DataServiceError extends Error {
    constructor(message, status, endpoint, method){
        super(message);
        this.name = 'DataServiceError';
        this.status = status;
        this.endpoint = endpoint;
        this.method = method;
    }
};
let DataService = class DataService {
    static getInstance() {
        return DataService.instance;
    }
    /**
   * Helper to fetch JSON from a URL.
   */ async fetchJson(url, init) {
        var _init;
        const method = ((_init = init) === null || _init === void 0 ? void 0 : _init.method) || 'GET';
        try {
            const response = await fetch(url, init);
            return await (0, _jsonOrThrow.jsonOrThrow)(response);
        } catch (error) {
            throw new DataServiceError(error.message || error.toString(), error.status, url, method);
        }
    }
    /**
   * Creates a shortcut ID for the given Graph Configs.
   */ async updateShortcut(graphConfigs) {
        // Skip this call when running locally to avoid 500 errors from the proxy/backend.
        if (window.perf && window.perf.disable_shortcut_update) {
            return '';
        }
        if (graphConfigs.length === 0) {
            return '';
        }
        const body = {
            graphs: graphConfigs
        };
        const json = await this.fetchJson('/_/shortcut/update', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return json.id;
    }
    /**
   * Fetches the Graph Configs for a given shortcut ID.
   */ async getShortcut(id) {
        const body = {
            ID: id
        };
        const json = await this.fetchJson('/_/shortcut/get', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return json.graphs;
    }
    /**
   * Fetches the initial page data.
   */ async getInitPage(tz) {
        return await this.fetchJson(`/_/initpage/?tz=${tz}`, {
            method: 'GET'
        });
    }
    /**
   * Fetches the default configuration.
   */ async getDefaults() {
        return await this.fetchJson('/_/defaults/', {
            method: 'GET'
        });
    }
    /**
   * Calculates the new range change based on a shift request.
   */ async shift(req) {
        return await this.fetchJson('/_/shift/', {
            method: 'POST',
            body: JSON.stringify(req),
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    /**
   * Fetches user issues for the given trace keys and commit range.
   */ async getUserIssues(req) {
        return await this.fetchJson('/_/user_issues/', {
            method: 'POST',
            body: JSON.stringify(req),
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    /**
   * Fetches regressions for a given range.
   */ async sendRegressionRangeRequest(req) {
        return await this.fetchJson('/_/reg', {
            method: 'POST',
            body: JSON.stringify(req),
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    /**
   * Fetches specific trace values for a given commit range.
   */ async fetchTraceValues(req) {
        return await this.fetchJson('/_/trace_values', {
            method: 'POST',
            body: JSON.stringify(req),
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    /**
   * Starts the frame request and returns the resulting data.
   *
   * @param body - The frame request body.
   * @param options - Optional configuration for the request lifecycle and callbacks.
   */ async sendFrameRequest(body, options = {}) {
        body.tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const requestOptions = {
            onStart: options.onStart,
            onSettled: options.onSettled,
            pollingIntervalMs: options.pollingIntervalMs,
            onProgressUpdate: (prog)=>{
                if (options.onProgress) {
                    options.onProgress((0, _progress.messagesToPreString)(prog.messages || []));
                }
            }
        };
        const finishedProg = await (0, _progress.startRequest)('/_/frame/start', body, requestOptions);
        if (finishedProg.status !== 'Finished') {
            throw new DataServiceError((0, _progress.messagesToErrorString)(finishedProg.messages));
        }
        const msg = (0, _progress.messageByName)(finishedProg.messages, 'Message');
        if (msg && options.onMessage) {
            options.onMessage(msg);
        }
        return finishedProg.results;
    }
    /**
   * Fetches the subrepo links for a batch of commits and traces.
   */ async getLinksBatch(commitNumbers, traceIds) {
        const body = {
            commit_numbers: commitNumbers,
            trace_ids: traceIds
        };
        return await this.fetchJson('/_/links_batch', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    constructor(){}
};
(()=>{
    DataService.instance = new DataService();
})();
